const messages = {
  deleted: "Mensaje eliminado",
};

export default messages;
